export default {
  computed: {
    campaignId() {
      return this.$route.params.campaignId;
    },
  },
};
